import { toast } from 'react-toastify';
import i18n from '@/i18n';
import { INFO_TOAST_ID, LIMITED_CONTAINER_ID } from '@/config';

const showEmailConfirmationToast = () =>
  toast.info(i18n.t('translation.confirm_email_notice'), {
    toastId: INFO_TOAST_ID,
    containerId: LIMITED_CONTAINER_ID,
  });

export default showEmailConfirmationToast;
